/**
 * This module imports icons from the "lucide" package and creates them using the "createIcons" function.
 * @module icons
 */
import {
    createIcons,
    AlertTriangle,
    ArrowUp,
    ArrowUpDown,
    Bold,
    CalendarDays,
    CheckCircle,
    ChevronDown,
    ChevronUp,
    Clock3,
    Download,
    FileImage,
    FileText,
    Italic,
    Link,
    List,
    ListOrdered,
    Loader2,
    Lock,
    LogOut,
    Mail,
    Menu,
    MoreHorizontal,
    MoveDown,
    Pencil,
    Plus,
    Printer,
    Redo2,
    Search,
    Settings,
    Trash2,
    Undo2,
    Unlock,
    Upload,
    User2,
    X,
} from "lucide";

createIcons({
    icons: {
        AlertTriangle,
        ArrowUp,
        ArrowUpDown,
        Bold,
        CalendarDays,
        CheckCircle,
        ChevronDown,
        ChevronUp,
        Clock3,
        Download,
        FileImage,
        FileText,
        Italic,
        Link,
        List,
        ListOrdered,
        Loader2,
        Lock,
        LogOut,
        Mail,
        Menu,
        MoreHorizontal,
        MoveDown,
        Pencil,
        Plus,
        Printer,
        Redo2,
        Search,
        Settings,
        Trash2,
        Undo2,
        Unlock,
        Upload,
        User2,
        X,
    },
});
